export const DEFAULT_IDENTIFICATIONS = [
    'BIR',
    'SSS',
    'Phil Health'
]


// WEBPACK FOOTER //
// ./src/app/contants/DEFAULT_IDENTIFICATIONS.ts